export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./settingsDialog.vue?vue&type=template&id=c8847f04&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom/components/settingsDialog.vue?vue&type=template&id=c8847f04&scoped=true&
// module id = null
// module chunks = 